module.exports = __webpack_public_path__ + "img/product_10.90cca87.webp";